<template>
    <div class="container">
        <img :src="imagem" alt="" class="img-instrucao" />
        <p class="texto">{{ texto }}</p>
    </div>
</template>

<script>
export default {
    name: "DemonstrativoLerComanda",
    props: {
        imagem: String,
        texto: String,
    },
}
</script>

<style scoped>
.container {
    display: flex;
    padding-inline: var(--padding-padrao);
    align-items:center;
    padding-bottom: var(--padding-padrao);
}
.img-instrucao {
    max-width: 150px;
    display: block;
    padding: var(--padding-padrao)
}
.texto {
    text-align: left;
    color: black;
    padding: var(--padding-padrao)
}
</style>
